<hr class="mb-3" />
<div
  download
  [url]="downloadLink"
  (downloadFailed)="onFileDownloadError()"
  (downloadChanged)="onFileDownloadChanged($event)"
  data-test-id="div-notification"
  (click)="handleAreaMessageElementClick(data)"
  [ngClass]="{ navigatable: data && data.routerUrl }"
  ngbDropdownItem
>
  <p class="d-inline-block mb-2" *ngIf="data" data-test-id="message">
    <span
      *ngFor="let chunk of data.message; index as i"
      [attr.data-test-id]="'chunk-' + i"
      class="text-break"
      [class.text-primary]="chunk.href || chunk.fileId"
      [attr.role]="chunk.href || chunk.fileId ? 'button' : ''"
      [class]="chunk.href || chunk.fileId ? 'btn-link' : ''"
      (click)="handleMessageElementClick(chunk); $event.stopPropagation()"
    >
      {{ chunk.text }}
    </span>
  </p>
  <div class="d-flex align-items-center justify-content-between">
    <time data-test-id="date-created" class="text-truncate small" [dateTime]="data?.dateCreated">{{
      data?.dateCreated | date: DATE_TIME_FORMAT_SHORT
    }}</time>
    <button data-test-id="dismiss-button" class="btn btn-sm btn-outline-secondary" (click)="onActionExecuted()">
      Dismiss
    </button>
  </div>
</div>
<ng-container *ngIf="isFileDownloading">
  <div data-test-id="file-downloading-spinner" class="center">
    <div class="spinner-border" role="status"></div>
  </div>
</ng-container>
